import { combineReducers } from 'redux'

import user from "./user.reducer"
import test from "./test.reducer"

export default combineReducers({user,test})
